import * as React from 'react';
import styled from 'styled-components';
import { DSListProps, DSList, DSListItem, DSListItemIcon, DSListItemText } from '../mui/List';

type ListOptionWithImg = {
    src: any;
    size?: number;
    alt?: string;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isListOptionWithImg = (item: any): item is ListOptionWithImg => item.src !== undefined;

type ListOptionWithComponentIcon = {
    icon: JSX.Element;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isListOptionWithComponentIcon = (item: any): item is ListOptionWithComponentIcon => item.icon !== undefined;

type ListOptionWithGlyphicon = {
    glyphicon: string;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isListOptionWithGlyphicon = (item: any): item is ListOptionWithGlyphicon => item.glyphicon !== undefined;

type ListOptionWithClass = {
    iconClass: string;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isListOptionWithClass = (item: any): item is ListOptionWithClass => item.class !== undefined;

const StyledDSListItemIcon = styled(DSListItemIcon)`
    font-size: 24px;
`;

export type ListOption = {
    display: string;
    key: string;
    hidden?: boolean;
} & (ListOptionWithClass | ListOptionWithComponentIcon | ListOptionWithGlyphicon | ListOptionWithImg);

export type WellListProps = Omit<DSListProps, 'onChange'> & {
    onChange: (key: ListOption['key']) => void;
    options: ListOption[];
    selected?: ListOption['key'];
};

export const WellList: React.FC<WellListProps> = ({ onChange, options, selected, ...props }) => (
    <DSList {...props}>
        {options
            .filter(option => !option.hidden)
            .map(option => (
                <DSListItem
                    button
                    component="li"
                    hidden={option.hidden}
                    key={option.key}
                    selected={option.key === selected}
                    onClick={() => !option.hidden && onChange(option.key)}
                >
                    {/* Todo: This isn't the best way to enforce consistent icon size, but it will do for now */}
                    <StyledDSListItemIcon>
                        <ListIcon option={option} />
                    </StyledDSListItemIcon>
                    <DSListItemText>{option.display}</DSListItemText>
                </DSListItem>
            ))}
    </DSList>
);
WellList.displayName = 'WellList';

export type ListIconProps = {
    option: ListOption;
};

export const ListIcon: React.FC<ListIconProps> = ({ option }) => {
    if (isListOptionWithClass(option)) {
        return <span className={option.iconClass} />;
    } else if (isListOptionWithComponentIcon(option)) {
        return option.icon;
    } else if (isListOptionWithGlyphicon(option)) {
        return <i className={`glyphicon ${option.glyphicon}`} />;
    } else if (isListOptionWithImg(option)) {
        return (
            <img
                alt={option.alt}
                height={`${option.size ?? '26'}px`}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                src={option.src}
                width={`${option.size ?? '26'}px`}
            />
        );
    }
    return <div />;
};
ListIcon.displayName = 'ListIcon';
